import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';

import { get, isArray } from 'lodash';

import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { ContainerForm } from './styles';
import { Input } from '~/components/Form';

import { t } from '~/helpers';
import api from '~/services/api';

export default function MyForm({ data, reference, close }) {

  const { profile } = useSelector((state) => state.user);

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({

          avbf_observacao: Yup.string()        
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, t('s.geral.validacao.tamanhominimo').replace('%s', 1))
          .max(499, t('s.geral.validacao.tamanhomaximo').replace('%s', 499))          
          
      });

      const login = get(profile, 'glousuariologin', '');
     // const codigo_frentista = get(usuarioacesso, 'usua_login', '');
      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        placa: data.veic_placa,
        placa_aux: data.veic_placa_aux,
        pleito_codigo: data.veic_codigo_pleito,
        login: login ,
        acao: 'A', //?
        observacao: param.avbf_observacao
      };

      await api.put('operacaobloqueioveiculoprefaturahistoricoitem/alterar', objSend);
      toast.success(t('s.geral.sucessoalteracao'));

      await close();
    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }

      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    reference.current.setData(data);
  }, []);

  return (
    <>
     <ContainerForm ref={reference} initialData={data} onSubmit={handleSubmit}>
        <Input
          name='veic_placa_aux'
          label='Placa' 
          disabled                   
        />

        <Input
        name = 'veic_codigo_pleito'
        label = 'Pleito'
        type = "text"
        />

        <Input 
        name= 'avbf_observacao'
        label='Observação'
        type = "text"
        multiline
        rows={10}
        />
         </ContainerForm>
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
